import events from '../events';
import usersApiClient from '../login-register/UsersApiClient';
export function PasswordChange(model) {
    return {
        ...model,
        success: false,
        errorMessage: '',
        isLoading: false,
        submit(e) {
            const newPassword = e.target.newPassword.value;
            const repeatPassword = e.target.repeatPassword.value;
            const data = {
                token: this.token,
                newPassword,
                repeatPassword,
            };
            this.errorMessage = '';
            this.isLoading = true;
            usersApiClient.resetPassword(data)
                .then(success => {
                this.success = success;
            })
                .catch(err => {
                if (err.status === 400) {
                    this.errorMessage = err.data[0].errorMessage;
                }
            })
                .finally(() => this.isLoading = false);
        },
        login() {
            events.openLogin.trigger({ open: true, centeredFixed: true });
        },
    };
}
